import React from 'react';
import AdminUserDetailContainer from '../components/adminUserDetail.container';

/** `/admin/users/:userId` — one account. `:userId` is `public.users.id`, never the Supabase id. */
const AdminUserDetailPage: React.FC = () => <AdminUserDetailContainer />;

export default AdminUserDetailPage;
